import { PublicPage } from 'api/website';

import { getContentLocaleUrl } from './getContentLocaleUrl';

type Props = {
  content: PublicPage;
};

export function getContentPageUrl({ content }: Props) {
  const contentLocaleUrl = getContentLocaleUrl({ content });
  return contentLocaleUrl[content.locale];
}
